import React, { useState } from 'react';
import { Leaf } from 'lucide-react';
import menuData from '../data/menu.json';
import SEO from '../components/SEO';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('klassiker');

  return (
    <div className="pt-20">
      <SEO 
        title="Menü - Ali Baba Kebab & Vegie Sarnen | Speisekarte & Preise"
        description="Entdecken Sie unsere vielfältige Speisekarte: Kebab, Döner, Falafel, Pide, Pizza, Burger & mehr. Vegetarische und vegane Optionen. Preise ab CHF 9. Jetzt online ansehen!"
        keywords="Kebab Menü, Döner Preise, Falafel Sarnen, Pide Sarnen, Vegetarisches Menü, Speisekarte Sarnen"
        path="/menu"
      />
      
      {/* Hero */}
      <section className="section bg-[#1C1917] text-center">
        <div className="container mx-auto">
          <h1 className="text-6xl md:text-7xl text-white mb-6">UNSER MENÜ</h1>
          <p className="text-xl text-[#F7E39A] max-w-3xl mx-auto">
            Entdecken Sie unsere vielfältige Auswahl an frisch zubereiteten Speisen
          </p>
        </div>
      </section>

      {/* Menu Categories */}
      <section className="section bg-[#0F0E0D]">
        <div className="container mx-auto">
          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {menuData.categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all ${
                  activeCategory === category.id
                    ? 'bg-[#F7E39A] text-[#1C1917]'
                    : 'bg-[#2A2725] text-white hover:bg-[#F7E39A] hover:text-[#1C1917]'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>

          {/* Category Notes */}
          {menuData.categories.find((cat) => cat.id === activeCategory)?.notes && (
            <div className="mb-8 text-center">
              {menuData.categories.find((cat) => cat.id === activeCategory).notes.map((note, idx) => (
                <p key={idx} className="text-[#F7E39A] text-sm">{note}</p>
              ))}
            </div>
          )}

          {/* Menu Items */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {menuData.categories
              .find((cat) => cat.id === activeCategory)
              ?.items.map((item, index) => (
                <div
                  key={index}
                  className="bg-[#1C1917] p-6 rounded-lg transition-transform hover:scale-105"
                  style={{ border: '1px solid rgba(247, 227, 154, 0.3)' }}
                >
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl text-white font-semibold">{item.name}</h3>
                    {item.veggie && (
                      <Leaf className="text-[#A7C957] flex-shrink-0" size={24} />
                    )}
                  </div>
                  <p className="text-[#F7E39A] text-2xl font-bold">{item.price}</p>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section bg-[#F7E39A] text-[#1C1917]">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl font-bold mb-4">Hunger bekommen?</h2>
          <p className="text-xl mb-6">Rufen Sie uns an und bestellen Sie jetzt!</p>
          <a 
            href="tel:+41416602929" 
            className="bg-[#1C1917] text-white px-8 py-4 rounded-lg font-semibold text-lg inline-block transition-transform hover:scale-105"
          >
            041 660 29 29
          </a>
        </div>
      </section>
    </div>
  );
};

export default Menu;
